import container from 'modules/section-content';
import page from 'page';
import domify from 'domify';
import React from 'react';
import { throttle } from 'lodash';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import splash from './view/main.pug';
import metadata from './metadata.json';
import bodymovin from 'bodymovin';
import inView from 'in-view';
import animationFunnel from './animations/funnel/data.json';
import animationPhone from './animations/phone/data.json';

const metricsLib = window.metricsLib;
const mouseFlow = window.mouseflow || undefined;

export default function register() {
  page('/b2b-enterprise-identity-management', render, snippets);
  page.exit('/b2b-enterprise-identity-management', unMountApp);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm source="b2b" subject="New lead from B2B page" />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  contactFormModals();
  initAnimation();
  return next();
}

function unMountApp(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  return next();
}

function initAnimation() {
  const containerFunnel = document.getElementById('animation-funnel');
  const containerPhone = document.getElementById('animation-phone');

  const params1 = {
    container: containerFunnel,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: animationFunnel
  };

  const params2 = {
    container: containerPhone,
    renderer: 'svg',
    loop: true,
    autoplay: false,
    animationData: animationPhone
  };

  var animFunnel = bodymovin.loadAnimation(params1);
  var animPhone = bodymovin.loadAnimation(params2);

  let funnelPlayState = false;
  let phonePlayState = false;

  inView.threshold(0.5);

  const playAnimationsIfVisible = throttle(() => {
    if (!funnelPlayState && inView.is(containerFunnel)) {
      animFunnel.play();
    }
    if (!phonePlayState && inView.is(containerPhone)) {
      animPhone.play();
    }
  }, 300);

  playAnimationsIfVisible();

  document.addEventListener('scroll', playAnimationsIfVisible);
}

function contactFormModals() {
  // Contact Sales Form
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:b2b-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitSuccess('#contact-form-modal__form') : null;
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:b2b-contact-form', metricsData);
      mouseFlow ? mouseFlow.formSubmitFailure('#contact-form-modal__form') : null;
    },
    source: 'b2b-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
    salesContactForm.show({ includePhoneField: true })
  );
}



// WEBPACK FOOTER //
// ./src/pages/b2b/b2b.js